import React, { useState, useEffect } from "react";

interface GradualBlurProps {
  containerRef: React.RefObject<HTMLDivElement | null>;
}

/**
 * GradualBlur Component
 * 
 * Carousel'lerin sağ ve sol taraflarında fade overlay efekti sağlar.
 * Scroll pozisyonuna göre dinamik olarak görünür/gizlenir.
 */
export const GradualBlur: React.FC<GradualBlurProps> = ({ containerRef }) => {
  const [showLeftOverlay, setShowLeftOverlay] = useState(false);
  const [showRightOverlay, setShowRightOverlay] = useState(true);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const updateOverlayVisibility = () => {
      const { scrollLeft, scrollWidth, clientWidth } = container;
      const isAtStart = scrollLeft <= 10;
      const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 10;

      setShowLeftOverlay(!isAtStart);
      setShowRightOverlay(!isAtEnd);
    };

    // Initial check
    updateOverlayVisibility();

    // Listen to scroll events
    container.addEventListener("scroll", updateOverlayVisibility);
    window.addEventListener("resize", updateOverlayVisibility);

    return () => {
      container.removeEventListener("scroll", updateOverlayVisibility);
      window.removeEventListener("resize", updateOverlayVisibility);
    };
  }, [containerRef]);

  return (
    <>
      {/* Left Overlay */}
      {showLeftOverlay && (
        <div
          className="pointer-events-none absolute left-0 top-0 z-10 h-full w-16 bg-gradient-to-r from-bg-primary via-bg-primary/80 to-transparent dark:from-bg-primary dark:via-bg-primary/80"
          aria-hidden="true"
        />
      )}

      {/* Right Overlay */}
      {showRightOverlay && (
        <div
          className="pointer-events-none absolute right-0 top-0 z-10 h-full w-16 bg-gradient-to-l from-bg-primary via-bg-primary/80 to-transparent dark:from-bg-primary dark:via-bg-primary/80"
          aria-hidden="true"
        />
      )}
    </>
  );
};

